/**
 * @function getBuilderDataAnalyticsProps
 * @description Takes an object of analytics properties (label and category) and
 *   returns data tracking attributes for use when setting HTML attributes conditionally
 *   based on the presence of the given data on a builder defined component
 * @param {Object} dataAnalytics Analytics label and category as set in builder for
 *   the given component
 * @returns {Object} HTML attributes to include on a DOM element for
 *   analytics tracking purposes
 */
export const getBuilderDataAnalyticsProps = (dataAnalytics) => {
  return {
    ...(dataAnalytics?.label && {
      'data-ga-label': `${dataAnalytics?.label}`,
    }),
    ...(dataAnalytics?.category && {
      'data-ga-category': `${dataAnalytics?.category}`,
    }),
  };
};
